import React, { useState } from "react";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

import "./SideNav.css";

let rememberedCollapsed = false;

export function getSideNavCollapsed() {
  return rememberedCollapsed;
}

export default function SideNav({
  items = [],
  activeKey,
  onItemClick,
  collapsed: collapsedProp,
  onCollapsedChange,
  collapsible = true,
  className = "",
  ariaLabel = "Side navigation",
}) {
  const isControlled = collapsedProp !== undefined;
  const [internalCollapsed, setInternalCollapsed] = useState(rememberedCollapsed);
  const collapsed = isControlled ? collapsedProp : internalCollapsed;

  const setCollapsed = (next) => {
    rememberedCollapsed = next;
    if (!isControlled) {
      setInternalCollapsed(next);
    }
    if (typeof onCollapsedChange === "function") {
      onCollapsedChange(next);
    }
  };

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleItemClick = (item) => {
    if (item.disabled) return;
    if (typeof onItemClick === "function") {
      onItemClick(item);
    }
  };

  return (
    <aside
      className={`SideNav${collapsed ? " SideNav--collapsed" : ""} ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {collapsible && (
        <Button
          type="primary"
          className="SideNav__Toggle"
          icon={collapsed
            ? <RightOutlined className="SideNav__ToggleIcon" />
            : <LeftOutlined className="SideNav__ToggleIcon" />}
          aria-expanded={!collapsed}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          onClick={handleToggle}
        />
      )}

      <nav className="SideNav__Nav">
        <ul className="SideNav__List">
          {items.map((item) => {
            const isActive = item.key === activeKey;
            const icon = isActive && item.iconActive != null
              ? item.iconActive
              : item.icon;

            const itemButton = (
              <Button
                type="text"
                block
                className={`SideNav__Item${isActive ? " SideNav__Item--active" : ""}`}
                icon={icon != null ? (
                  <span className="SideNav__ItemIcon" aria-hidden>
                    {icon}
                  </span>
                ) : undefined}
                disabled={item.disabled}
                aria-current={isActive ? "page" : undefined}
                aria-label={item.label}
                onClick={() => handleItemClick(item)}
              >
                <span className="SideNav__ItemLabel">{item.label}</span>
              </Button>
            );

            return (
              <li key={item.key} className="SideNav__ListItem">
                <Tooltip
                  title={collapsed ? item.label : ""}
                  placement="right"
                  mouseEnterDelay={0.2}
                >
                  {itemButton}
                </Tooltip>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
